import {useMemo} from 'react';

import {Box, MenuItem, TextField} from '@mui/material';
import {Controller, useFormContext} from 'react-hook-form';

import {REPORT_DATASOURCES_AUTHENTICATION_METHODS, REPORT_DATASOURCES_PRIVACY_LEVELS} from '../../../../const';
import {sourceShape} from '../../../../proptypes-shapes';
import Checkbox from '../../../form/Checkbox/Checkbox';
import PasswordInputRevealable from '../../../form/PasswordRevealableInput/PasswordInputRevealable';

const UpdateSourceForm = ({source}) => {
  const {control, register, watch} = useFormContext();

  const selectedAuthenticationMethodId = watch('authenticationMethod');
  const authenticationMethods = useMemo(() => Object.values(REPORT_DATASOURCES_AUTHENTICATION_METHODS), []);
  const selectedAuthenticationMethod = useMemo(() => authenticationMethods.find(method => method.id === selectedAuthenticationMethodId), [authenticationMethods, selectedAuthenticationMethodId]);

  const renderAuthenticationSelect = () => {
    if (!source.credentials?.length) return null;

    return (
      <Controller
        name="authenticationMethod"
        control={control}
        rules={{required: true}}
        render={({field, fieldState}) => (
          <TextField
            {...field}
            select
            required
            fullWidth
            label="Choisissez la méthode d'authentification ..."
            InputLabelProps={{shrink: true}}
            error={!!fieldState.error}
            helperText={fieldState.error ? 'Champ requis' : ''}
            sx={{mb: 3}}
          >
            {source.credentials.map(credential => (
              <MenuItem key={credential} value={credential}>
                {credential}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    );
  };

  const renderDynamicFields = () => {
    if (!selectedAuthenticationMethod?.formFields?.length) return null;

    return selectedAuthenticationMethod.formFields.map(field => {
      if (field.type === 'password') {
        return (
          <Controller
            key={field.id}
            name={field.id}
            control={control}
            defaultValue=""
            rules={{required: true}}
            render={({field: controllerField}) => <PasswordInputRevealable {...controllerField} label={field.label} placeholder={field.label} fullWidth required sx={{mb: 3}} />}
          />
        );
      }

      return <TextField key={field.id} required fullWidth label={field.label} placeholder={field.label} InputLabelProps={{shrink: true}} sx={{mb: 3}} {...register(field.id, {required: true})} />;
    });
  };

  return (
    <Box>
      <TextField
        disabled
        required
        fullWidth
        label="Adresse de la source "
        placeholder="Choisissez la source ..."
        InputLabelProps={{shrink: true}}
        sx={{mb: 3}}
        {...register('address', {required: true})}
      />

      {renderAuthenticationSelect()}

      {renderDynamicFields()}

      <Controller
        name="privacyLevel"
        control={control}
        rules={{required: true}}
        render={({field, fieldState}) => (
          <TextField
            {...field}
            select
            required
            fullWidth
            label="Niveau de confidentialité ..."
            InputLabelProps={{shrink: true}}
            error={!!fieldState.error}
            helperText={fieldState.error ? 'Champ requis' : ''}
            sx={{mb: 2}}
          >
            {Object.values(REPORT_DATASOURCES_PRIVACY_LEVELS).map(level => (
              <MenuItem key={level.id} value={level.id}>
                {level.label}
              </MenuItem>
            ))}
          </TextField>
        )}
      />

      <Controller name="shouldIgnoreConnectionTest" control={control} defaultValue={false} render={({field}) => <Checkbox {...field} checked={field.value} label="Ignorer le test de connexion" />} />
    </Box>
  );
};

UpdateSourceForm.propTypes = {
  source: sourceShape.isRequired
};

export default UpdateSourceForm;
